/* tslint:disable */

declare var Object: any;
export interface SunfishInterface {
  "id"?: number;
}

export class Sunfish implements SunfishInterface {
  "id": number;
  constructor(data?: SunfishInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Sunfish`.
   */
  public static getModelName() {
    return "Sunfish";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Sunfish for dynamic purposes.
  **/
  public static factory(data: SunfishInterface): Sunfish{
    return new Sunfish(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Sunfish',
      plural: 'Sunfishes',
      path: 'Sunfishes',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Sunfish.ts